// extracted by mini-css-extract-plugin
export default {"titleContainer":"SendMessageModal_titleContainer__b9IW0"};